import { useMemo } from "react";

import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";
import {
  getTrendDirection,
  getTrendColor,
  getMeasureFormat,
  formatTrendValue,
  getFirstRow,
} from "../helpers/functions";

export default function MetricCard({ dimensions, measures, record }) {
  const raw = record?.raw ?? null;
  const row = getFirstRow(raw);

  const primaryKey = dimensions?.[0]?.data_key;
  const primaryFormat = useMemo(
    () => getMeasureFormat(measures, primaryKey),
    [measures, primaryKey]
  );
  const primaryValue = row && primaryKey ? row[primaryKey] : null;
  const primaryTrendKey = primaryKey ? `${primaryKey}__trend` : null;
  const primaryTrendValue = row && primaryTrendKey ? row[primaryTrendKey] : null;
  const primaryTrendDirection = getTrendDirection(primaryTrendValue);

  const rows = useMemo(() => {
    const seenKeys = new Set();
    return (dimensions ?? []).slice(1).reduce((acc, dimension) => {
      const key = dimension?.data_key;
      if (key && seenKeys.has(key)) {
        return acc;
      }
      if (key) {
        seenKeys.add(key);
      }
      const label = dimension?.label ?? "";
      const format = getMeasureFormat(measures, key);
      const value = row && key ? row[key] : null;
      const trendKey = key ? `${key}__trend` : null;
      const trendValue = row && trendKey ? row[trendKey] : null;
      const direction = getTrendDirection(trendValue);
      acc.push({ key, label, format, value, trendValue, direction });
      return acc;
    }, []);
  }, [dimensions, measures, row]);

  return (
    <>
      <div className="flex items-center justify-between gap-4 mb-4">
        <div className="text-5xl font-light">{formatTrendValue(primaryValue, primaryFormat)}</div>
        <div>
          {primaryTrendDirection === "up" || primaryTrendDirection === "down" ? (
            <Svg
              name={primaryTrendDirection === "up" ? SvgEnum.HisArrowUp : SvgEnum.HisArrowDown}
              color={getTrendColor(primaryTrendDirection)}
              sx={{ width: 32, height: 32 }}
            />
          ) : (
            "—"
          )}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {rows.map((row) => (
          <div key={row.key} className="flex items-center justify-between gap-3 pt-2 border-t">
            <div className="text-xs">{row.label}</div>
            <div className="inline-flex items-center gap-2">
              <span
                className="inline-flex w-auto min-w-24 max-w-28 items-center justify-between gap-2 rounded-full px-2 py-0.5 text-xs font-normal"
                style={{
                  backgroundColor:
                    row.direction === "down" ? HNSColors.failure[800] : HNSColors.success[800],
                  color: row.direction === "down" ? HNSColors.failure[500] : HNSColors.success[400],
                }}
              >
                {formatTrendValue(row.value, row.format)}
                <span>
                  {row.direction === "up" || row.direction === "down" ? (
                    <Svg
                      name={row.direction === "up" ? SvgEnum.HisArrowUp : SvgEnum.HisArrowDown}
                      color={getTrendColor(row.direction)}
                      sx={{ width: 14, height: 14 }}
                    />
                  ) : (
                    "—"
                  )}
                </span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
